"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var printSummary_styles_1 = require("./printSummary.styles");
var dateFormatter_1 = require("../../../util/formatter/dateFormatter");
var core_components_1 = require("@securityproducts/core-components");
var printSummary_i18n_1 = require("./printSummary.i18n");
function PrintSummary(props) {
    var fromDate = props.fromDate && dateFormatter_1.newDateFormatterLuxon(props.fromDate, "HOURS", "TOOLTIP", props.language);
    var toDate = props.toDate && dateFormatter_1.newDateFormatterLuxon(props.toDate, "HOURS", "TOOLTIP", props.language);
    var strings = core_components_1.useLocalisation(printSummary_i18n_1.printSummaryRangeTranslations, props.language);
    return (React.createElement("div", { className: printSummary_styles_1.container },
        React.createElement("div", { className: printSummary_styles_1.heading },
            React.createElement("div", null,
                React.createElement("b", null, props.type.toLowerCase() === "historical"
                    ? strings.historicalReport
                    : strings.activeReport)),
            props.group && (React.createElement("div", null,
                strings.for,
                " ",
                React.createElement("b", null, core_components_1.toTitleCase(props.group)))),
            props.agent && (React.createElement("div", null,
                strings.for,
                " ",
                React.createElement("b", null, core_components_1.toTitleCase(props.agent))))),
        React.createElement("div", { className: printSummary_styles_1.info },
            props.fromDate && props.toDate && (React.createElement("div", { className: printSummary_styles_1.infoRow },
                React.createElement("div", { className: printSummary_styles_1.infoLabel }, strings.dateRange),
                " ",
                React.createElement("div", { className: printSummary_styles_1.infoDetail },
                    fromDate,
                    " - ",
                    toDate))),
            props.timezone && props.timezoneAbbr && (React.createElement("div", { className: printSummary_styles_1.infoRow },
                React.createElement("div", { className: printSummary_styles_1.infoLabel }, strings.timeZone),
                " ",
                React.createElement("div", { className: printSummary_styles_1.infoDetail },
                    props.timezoneAbbr,
                    " - ",
                    props.timezone))))));
}
exports.PrintSummary = PrintSummary;
